<template>
    <div class="flex flex-col w-full justify-center gap-2 md:gap-2">
        <vx-box class="bg-slate-50 flex flex-col max-w-(--breakpoint-sm) p-8 text-xl mb-8" color="info">
            <h2 class="text-xl font-extrabold leading-7 text-slate-700">
                Segments
            </h2>
            <p class="text-sm font-sans text-slate-500 lg:text-base">
                Segments of this contact.
            </p>
        </vx-box>

        <div v-if="loading && !list.length" class="text-center py-10">
            <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
        </div>

        <template v-else-if="!loading && list.length === 0">
            <vx-box color="info" class="mt-8 flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
                There are no segments for this contact.
            </vx-box>
        </template>
        <template v-else>
            <vx-table v-if="list.length" class="xl:grid-cols-4" rowBreakpoint="xl">
                <vx-table-row isHeader>
                    <div>
                        ID
                    </div>
                    <div>
                        Name
                    </div>
                    <div>
                        Audience Type
                    </div>
                    <div>
                        Refresh Type
                    </div>
                </vx-table-row>
                <contact-promotion-row v-for="(item, index) in list"
                    v-model="list[index]"
                    :key="item.id"></contact-promotion-row>
            </vx-table>
        </template>
    </div>
</template>

<script setup>

import { VxBox, VxIconLoading, VxTable, VxTableRow } from '@voxie/frontend-components';
import { contactsClient } from '~/services';
import ContactPromotionRow from './ContactSegmentRow.vue';
import { onMounted, ref } from 'vue';
import { useToasted } from '../../../../composables/useToasted';

const props = defineProps({
    contactId: {
        type: Number,
        required: true,
    },
});

const loading = ref(false);
const list = ref([]);
const toasted = useToasted();

onMounted(() => {
    getSegments();
});

const getSegments = async() => {
    if (loading.value) {
        return;
    }

    loading.value = true;
    try {
        const response = await contactsClient.getContactSegments(
            Spark.state.currentTeam.id,
            props.contactId,
            { per_page: 100 }
        );

        list.value = response.data.data;
    } catch (e) {
        console.error(e);
        toasted.global.platform_error();
    } finally {
        loading.value = false;
    }
};
</script>
